<template>
    <div class="user-change-grant-level">
        <el-dialog title="Changement d'autorisation" :visible.sync="innerVisible" size="tiny" :close-on-click-modal="false">

            <div class="grant-type-selection" v-show="showAccessTypeSelection">
                <el-row :gutter="12" v-if="!canTemporaryGrant">
                    <el-col :span="24">
                        <div class="alert alert-error alert-block">
                            <h4 style="text-align: left;">Génération d'accès temporaire impossible</h4>
                            La génération d'accès temporaire est impossible pour cette utilisateur car celui-ci est déjà un administrateur permanent.
                            <br/> Si vous est par contre possible de modifier son accès permanent.
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="12" class="grant-buttons">
                    <el-col :span="12">
                        <div style="text-align:center;">
                            <pcr-grant-level-label :grant-level="user.Rights.PermanentGrantLevel" remove-icons></pcr-grant-level-label>
                        </div>
                        <el-button type="default" @click="goToPermanent()">
                            <span v-show="!HasPermanentAccess">Générer un accès
                                <b>permanent</b>
                            </span>
                            <span v-show="HasPermanentAccess">Modifier l'accès
                                <b>permanent</b>
                            </span>
                        </el-button>
                    </el-col>
                    <el-col :span="12">
                        <div style="text-align:center;">
                            <pcr-grant-level-label :grant-level="user.Rights.TemporaryGrantLevel" remove-icons></pcr-grant-level-label>
                        </div>
                        <el-button type="default" :disabled="!canTemporaryGrant" @click="goToTemporary()">
                            <span v-show="!HasTemporaryAccess">Générer un accès
                                <b>temporaire</b>
                            </span>
                            <span v-show="HasTemporaryAccess">Modifier l'accès
                                <b>temporaire</b>
                            </span>
                        </el-button>
                    </el-col>
                </el-row>
                <el-row :gutter="12" class="grant-buttons">
                    <el-col :span="12">
                        <el-button type="danger" @click="removePermanent()" :disabled="!HasPermanentAccess">Supprimer l'accès permanent</el-button>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="danger" @click="removeTemporary()" :disabled="!HasTemporaryAccess">Supprimer l'accès temporaire</el-button>
                    </el-col>
                </el-row>
            </div>

            <div v-if="accessType == 'permanent'">
                <ck-form ref='change-user-grant-level' label-position="top">
                    <div v-if="user">
                        <el-row :gutter="12">
                            <el-col :span="24">
                                <div class="alert alert-error alert-block">
                                    <h4 style="text-align: left;">Attention</h4>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                </div>
                            </el-col>
                        </el-row>
                        
                        <el-row :gutter="12">
                            <el-col :span="24">
                                <div class="alert alert-error alert-block" v-if="!user.RegistrationDate">
                                    <h4 style="text-align: left;">Attention</h4>
                                    Un e-mail d'invitation sera envoyé.
                                </div>
                            </el-col>
                        </el-row>

                        <el-row :gutter="12">
                            <el-col :span="24">
                                <ck-form-item label="Autorisation">
                                    <el-select v-model="selectedGrantLevel" placeholder="Select">
                                        <el-option v-for="item in grantLevels" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <ck-validator :validators="{ validator: $ckValidator.required, model: selectedGrantLevel, trigger: 'change' }">
                                        Veuillez indiquer le niveau d'autorisation
                                    </ck-validator>
                                </ck-form-item>
                            </el-col>
                        </el-row>

                        <div>
                            <div class="pull-right">
                                <el-button type="default" @click="back">Annuler</el-button>
                                <el-button type="primary" @click="endPermanent" native-type="submit" :disabled="!user">Enregistrer</el-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </ck-form>
            </div>

            <div v-if="accessType == 'temporary'">
                <ck-form ref='change-user-grant-level' label-position="top">
                    <div v-if="user">
                        <el-row :gutter="12">
                            <el-col :span="24">
                                <div class="alert alert-error alert-block">
                                    <h4 style="text-align: left;">Attention</h4>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                </div>
                            </el-col>
                        </el-row>
                        
                        <el-row :gutter="12">
                            <el-col :span="24">
                                <div class="alert alert-error alert-block" v-if="!user.RegistrationDate">
                                    <h4 style="text-align: left;">Attention</h4>
                                    Un e-mail d'invitation sera envoyé.
                                </div>
                            </el-col>
                        </el-row>

                        <el-row :gutter="12">
                            <el-col :span="12">
                                <ck-form-item label="Autorisation">
                                    <el-select v-model="selectedGrantLevel" placeholder="Select">
                                        <el-option v-for="item in temporaryGrantLevels" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <ck-validator :validators="{ validator: $ckValidator.required, model: selectedGrantLevel, trigger: 'change' }">
                                        Veuillez indiquer le niveau d'autorisation
                                    </ck-validator>
                                </ck-form-item>
                            </el-col>
                            <el-col :span="12">
                                <ck-form-item label="Intervalle">
                                    <el-date-picker v-model="selectedDateRange" type="daterange" placeholder="Sélectionner l'intervalle..." :picker-options="pickerOptions" format="dd/MM/yyyy">
                                    </el-date-picker>
                                    <ck-validator :validators="{ validator: $ckValidator.required, model: selectedGrantLevel, trigger: 'change' }">
                                        Veuillez indiquer le niveau d'autorisation
                                    </ck-validator>
                                </ck-form-item>
                            </el-col>
                        </el-row>

                        <div>
                            <div class="pull-right">
                                <el-button type="default" @click="back">Annuler</el-button>
                                <el-button type="primary" @click="endTemporary" native-type="submit" :disabled="!user">Enregistrer</el-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </ck-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.component('change-user-grant-level-modal', {
    props: {
        zoneId: {
            default: () => 0
        },
        userId: {
            default: () => 0
        },
        visible: Boolean
    },
    data() {
        return {
            user: {
                Rights: {}
            },
            selectedGrantLevel: 0,
            innerVisible: false,

            grantLevels: [
                { value: 0, label: 'Aucune' },
                { value: 8, label: 'Contact' },
                { value: 16, label: 'Viewer' },
                { value: 64, label: 'Editeur' },
                { value: 112, label: 'Administrateur' }
            ],
            yesterday: new Date(new Date().getTime() - (24 * 60 * 60 * 1000)),
            accessType: '',
            selectedDateRange: undefined,
            pickerOptions: {
                disabledDate: (date) => {
                    return date < this.yesterday;
                }
            }
        }
    },
    computed: {
        temporaryGrantLevels() {
            return _.filter(this.grantLevels, (item) => item.value > 8 && item.value > this.user.Rights.PermanentGrantLevel);
        },
        canTemporaryGrant() {
            return this.user.Rights.PermanentGrantLevel < this.$grantLevel.administrator;
        },
        showAccessTypeSelection() {
            return this.accessType == '';
        },
        HasPermanentAccess() {
            return this.user.Rights.PermanentGrantLevel > this.$grantLevel.blind && this.user.Rights.IsExplicit;
        },
        HasTemporaryAccess() {
            return this.user.Rights.TemporaryGrantLevel > this.$grantLevel.blind && this.user.Rights.IsTemporary;
        }
    },
    mounted: function() {
        this.refresh();
    },
    methods: {
        refresh() {
            console.log('refresh')
            console.log('this.userId', this.userId)
            console.log('this.zoneId', this.zoneId)
            if (!this.refreshing && this.userId && this.zoneId) {
                this.refreshing = true;

                this.$http.get(`/api/user/${this.userId}/login/informations/${this.zoneId}`).then((response) => {
                    this.user = response.data;

                    if (this.user.Rights.IsTemporary) {
                        let startDate = new Date(parseInt(this.user.Rights.StartDate.replace("/Date(", "").replace(")/", ""), 10));
                        let endDate = new Date(parseInt(this.user.Rights.EndDate.replace("/Date(", "").replace(")/", ""), 10));
                        this.selectedDateRange = [startDate, endDate]
                    }

                    this.innerVisible = this.visible;

                    this.refreshing = false;
                }, () => this.refreshing = false);
            }
        },

        goToPermanent() {
            this.selectedGrantLevel = this.user.Rights.PermanentGrantLevel;
            this.accessType = 'permanent';
        },
        goToTemporary() {
            if (this.user.Rights.TemporaryGrantLevel > 0)
                this.selectedGrantLevel = this.user.Rights.TemporaryGrantLevel;
            else
                this.selectedGrantLevel = this.temporaryGrantLevels[0].value;
            this.accessType = 'temporary';
        },

        removePermanent() {
            this.$swal({
                type: 'warning',
                title: 'Suppression',
                text: 'Etes-vous sûr de vouloir supprimer cette autorisation permanent ?',
                showCancelButton: true,
                confirmButtonText: 'Confirmer',
                cancelButtonText: 'Annuler'
            }).then(() => {
                this.$http.delete(`/api/user/${this.userId}/grant/${this.zoneId}/permanent`).then((response) => {
                    this.$defaultSwalApiResponse(response, () => {
                        this.$swal({
                            type: 'success',
                            title: 'Supprimée',
                            text: 'L\'accès permanent a bien été supprimée'
                        }).then(() => {

                        });
                        this.reset();
                        this.$emit('on-save');
                        this.$root.$emit('pcr_update_data');
                        this.innerVisible = false;
                    }, this.$defaultSwalApiResponse);
                });
            });
        },
        removeTemporary() {
            this.$swal({
                type: 'warning',
                title: 'Suppression',
                text: 'Etes-vous sûr de vouloir supprimer cette autorisation temporaire ?',
                showCancelButton: true,
                confirmButtonText: 'Confirmer',
                cancelButtonText: 'Annuler'
            }).then(() => {
                this.$http.delete(`/api/user/${this.userId}/grant/${this.zoneId}/temporary`).then((response) => {
                    this.$defaultSwalApiResponse(response, () => {
                        this.$swal({
                            type: 'success',
                            title: 'Supprimée',
                            text: 'L\'accès temporaire a bien été supprimée'
                        }).then(() => {

                        });
                        this.reset();
                        this.$emit('on-save');
                        this.$root.$emit('pcr_update_data');
                        this.innerVisible = false;
                    });
                }, this.$defaultSwalApiResponse);
            });
        },

        reset() {
            this.accessType = '';
            this.refresh();
        },
        back() {
            this.accessType = '';
        },
        cancel(e) {
            this.innerVisible = false;
            this.$emit('on-cancel');
            this.reset();
        },
        endPermanent(e) {
            e.preventDefault();
            this.$refs['change-user-grant-level'].validate((valid) => {
                if (valid) {
                    this.$http.post(`/api/user/${this.userId}/grant/${this.zoneId}/permanent`, { grantLevel: this.selectedGrantLevel }).then((response) => {
                        this.$defaultSwalApiResponse(response, () => {
                            this.$swal({
                                type: 'success',
                                title: 'Enregistré',
                                text: 'L\'accès a bien été modifiée'
                            }).then(() => {

                            });
                            this.reset();
                            this.$emit('on-save');
                            this.$root.$emit('pcr_update_data');
                            this.innerVisible = false;
                        });
                    }, this.$defaultSwalApiResponse);
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        },
        endTemporary(e) {
            e.preventDefault();
            this.$refs['change-user-grant-level'].validate((valid) => {
                if (!this.selectedDateRange[0] || !this.selectedDateRange[1]) return false;

                if (valid) {
                    let model = {
                        grantLevel: this.selectedGrantLevel,
                        userId: this.userId,
                        zoneId: this.zoneId,
                        startDate: this.selectedDateRange[0],
                        endDate: this.selectedDateRange[1],
                    };
                    this.$http.post(`/api/user/${this.userId}/grant/${this.zoneId}/temporary`, model).then((response) => {
                        this.$defaultSwalApiResponse(response, () => {
                            this.$swal({
                                type: 'success',
                                title: 'Enregistré',
                                text: 'L\'accès a bien été modifiée'
                            }).then(() => {

                            });
                            this.reset();
                            this.$emit('on-save');
                            this.$root.$emit('pcr_update_data');
                            this.innerVisible = false;
                        });
                    }, this.$defaultSwalApiResponse);
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        }
    },
    watch: {
        innerVisible(val) {
            if (this.visible != val) {
                this.$emit('update:visible', val);
            }
        },
        visible(val) {
            console.log('visiblr')
            this.reset();
        }
    }
});
</script>

<style>
.grant-type-selection .grant-buttons .el-button.el-button--default {
    width: 100%;
    height: 120px;
    margin-top: 8px;
}

.grant-type-selection .grant-buttons .el-button.el-button--danger {
    width: 100%;
    margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/cross-components/change-user-grant-level-modal.vue